import { BrandThemeTokens } from './types';

export const presentearTheme: BrandThemeTokens = {
  palette: {
    primaryMain: '#ad8c63',
    secondaryMain: '#6f5b45',
    backgroundDefault: '#f9f5ef',
    surface: '#fffdfa',
    surfaceAlt: '#f5eee4',
    textPrimary: '#32281f',
    textSecondary: '#6a5d4e',
    heroGradientStart: '#fdf8f1',
    heroGradientEnd: '#eee3d2',
    heroGlow: 'rgba(102, 84, 59, 0.16)',
    borderSoft: 'rgba(103, 84, 58, 0.16)',
  },
  typography: {
    fontFamily: '"Lora", "Georgia", serif',
    headingFontFamily: '"Cormorant Garamond", "Times New Roman", serif',
    bodyFontFamily: '"Lora", "Georgia", serif',
    headingWeight: 600,
    bodyWeight: 400,
    buttonWeight: 600,
  },
};
